import { createContext } from 'react';

import type { XYChartThresholdsInternal } from '../types/xy-chart-internals.js';

export const NoThresholdData: XYChartThresholdsInternal = {
  none: true,
  thresholds: [],
  offset: {
    left: 0,
    right: 0,
  },
};

export const XYChartThresholdsContext =
  createContext<XYChartThresholdsInternal>(NoThresholdData);
